module.exports = __webpack_public_path__ + "static/img/Bachelor_010223.0854160.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010223.jpg
// module id = 122
// module chunks = 0